import React, { useEffect, useRef, useState } from "react";
import { AlteryxCommunityBtn, FabricBtn, GithubBtn, LinkedInBtn, TableauPublicBtn, TwitterBtn } from "../UIElements/SocialLinks";
import { Script } from "gatsby";

const svgPattern = (align) => (
    <svg className={`hidden lg:block absolute transform ${align === "right" ? "right-0" : "left-0"}`} width="404" height="300" fill="none" viewBox="0 0 404 300">
        <defs>
            <pattern id="svg-pattern-squares-1" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <line stroke="#e2e8f0" className="text-gray-200" id="svg_1" y2="3" x2="6" y1="3" x1="0" strokeWidth="1.5" fill="currentColor"></line>
                <line stroke="#e2e8f0" className="text-gray-200" id="svg_2" y2="6" x2="3" y1="0" x1="3" strokeWidth="1.5" fill="currentColor"></line>
            </pattern>
        </defs>
        <rect width="404" height="300" fill="url(#svg-pattern-squares-1)"></rect>
    </svg>
)

function PortableProfile({idx, accentColour, name, title, photo, location, html, slug, tableau, twitter, linkedIn, gitHub, alteryx, fabric, certifications}) {

    const [ certs, setCerts ] = useState([]);

    const credlyRef = useRef(null);


    const getMSCred = async (url) => {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({url})
        };
        try {
          const response = await fetch('https://a1en3a0nse.execute-api.eu-west-1.amazonaws.com/dev/mscert', requestOptions)
          const data = await response.json();
          return data;
        } catch(e) {
          console.log('[Author.js] fetch error', e);
          return null;
        }
      }

    useEffect(() => {
        const credlyArr = [];
        const msPromiseArr = [];
        let loadScript = false;
        certifications?.forEach((cred, idx) => {
          if (cred?.PublicShareUrl?.indexOf('credly.com') > -1) {
            loadScript = true;
            const regex = /badges?\/([0-9a-z-]+)/i;;
            const match = cred?.PublicShareUrl?.match(regex);
            if (match && match[1]) {
              credlyArr.push(
                <div key={match[1] + '-' + idx} className="bg-white w-[150px] h-[230px]">
                <div
                  data-iframe-width="150" 
                  data-iframe-height="270" 
                  data-share-badge-id={match[1]} 
                  data-share-badge-host="https://www.credly.com"
                  >
                </div>
                </div>
              )
            }
          }
          if (cred?.PublicShareUrl?.indexOf('learn.microsoft') > -1) {
            msPromiseArr.push(getMSCred(cred?.PublicShareUrl));
          }
        })
    
        if (msPromiseArr.length > 0) {
          Promise.all(msPromiseArr).then((results) => {
            results.forEach((cred, idx) => {
              credlyArr.push(
                <div key={cred.url} className="block w-[150px] h-[236px] border border-gray-200 rounded-sm p-2 bg-white">
                  <a href={cred.url} target="_blank" className="block">
                    <img src={cred.image} className="h-[110px] object-cover mt-3"/>
                    <div className="text-sm text-center mt-3">
                      {cred.title}
                    </div>
                  </a>
                </div>
              )
            })
            if (loadScript) {
              credlyArr.push(<Script id={credlyRef} src="//cdn.credly.com/assets/utilities/embed.js"/>)
            }
            setCerts(credlyArr);
          })
        } else {
          if (loadScript) {
            credlyArr.push(<Script id={credlyRef} src="//cdn.credly.com/assets/utilities/embed.js"/>)
          }
          setCerts(credlyArr);
        }
    
        
      }, [certifications])

    return (
        <>
            {svgPattern("right")}
            <div className={(idx > 0 ? "mt-16 lg:mt-24 " : "") + "relative lg:grid lg:grid-cols-2 lg:gap-8"}>
                <div className="relative">
                    <div className="flex flex-inline mb-14 sm:mb-0">
                        <div>
                            <h4 className={`text-2xl font-title font-semibold text-${accentColour ? accentColour : 'blue'}-700 leading-tight sm:text-3xl`}>
                                {name}
                            </h4>
                            <div className="text-lg font-title text-gray-600">
                                {title} - {location}
                            </div>
                            <div className="lg:hidden flex lg:items-center lg:justify-center -ml-2 lg:ml-0 my-4 lg:mt-6 lg:mb-0">
                                {tableau ? <TableauPublicBtn link={tableau} colour="blue"/> : null}
                                {alteryx ? <AlteryxCommunityBtn link={alteryx} colour="blue" /> : null}
                                {twitter ? <TwitterBtn link={twitter} colour="blue"/> : null}
                                {linkedIn ? <LinkedInBtn link={linkedIn} colour="blue"/> : null}
                                {gitHub ? <GithubBtn link={gitHub} colour="blue"/> : null}
                                {fabric ? <FabricBtn link={fabric} colour="blue"/> : null}
                            </div>
                        </div>
                        
                        <div className="block lg:hidden absolute right-0 mr-0 sm:mr-4 sm:-mt-16 mt-16">
                            {/* <Link to={"/blog/" + slug +"/"} > */}
                                <img className="relative mx-auto rounded-full" width="120" height="120" src={photo} alt="" />
                            {/* </Link> */}
                        </div>
                    </div>
                    <div className={`blog-content mt-3 leading-7 ${'main-page-text-' + accentColour} text-[15px]`} dangerouslySetInnerHTML={{ __html: html }}>
                    </div>
                    {certs?.length > 0 ?
                    <div className=" max-w-screen-xl mx-auto flex flex-wrap pt-4">
                        <div className='w-full -lg:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:columns-[150px] gap-1 content-center p-4'>
                        {certs}
                        </div>
                    </div>
                : null }
                </div>

                <div className="hidden mt-10 -mx-4 relative lg:mt-0 lg:block">
                    {/* <Link to={"/blog/" + slug +"/"} > */}
                        <img className={`${idx === 0 ? 'mt-10' : ''} relative mx-auto rounded-full`} width="300" src={photo} alt="" />
                        <div className="flex items-center justify-center mt-6">
                            {tableau ? <TableauPublicBtn link={tableau} colour="blue"/> : null}
                            {alteryx ? <AlteryxCommunityBtn link={alteryx} colour="blue" /> : null}
                            {twitter ? <TwitterBtn link={twitter} colour="blue"/> : null}
                            {linkedIn ? <LinkedInBtn link={linkedIn} colour="blue"/> : null}
                            {gitHub ? <GithubBtn link={gitHub} colour="blue"/> : null}
                            {fabric ? <FabricBtn link={fabric} colour="blue"/> : null}
                        </div>
                    {/* </Link> */}
                </div>
            </div>
        </>
    )

}

export default PortableProfile;